import * as PropTypes from "prop-types";
import ScheduleType from "./scheduleType";

const VenueType = PropTypes.shape({
  address: PropTypes.string,
  location: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  name: PropTypes.string,
  id: PropTypes.string,
  phones: PropTypes.arrayOf(PropTypes.shape({
    number: PropTypes.string,
    phone: PropTypes.bool,
    whatsapp: PropTypes.bool,
  })),
  schedule: ScheduleType,
});

export default VenueType;
